module.exports = __webpack_public_path__ + "img/characters30Off.479ffe3a.svg";